import { render, staticRenderFns } from "./well.vue?vue&type=template&id=d8c8f7e2&scoped=true"
import script from "./well.vue?vue&type=script&lang=js"
export * from "./well.vue?vue&type=script&lang=js"
import style0 from "./well.vue?vue&type=style&index=0&id=d8c8f7e2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c8f7e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c8f7e2')) {
      api.createRecord('d8c8f7e2', component.options)
    } else {
      api.reload('d8c8f7e2', component.options)
    }
    module.hot.accept("./well.vue?vue&type=template&id=d8c8f7e2&scoped=true", function () {
      api.rerender('d8c8f7e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/components/well.vue"
export default component.exports